// extracted by mini-css-extract-plugin
export default {"DrugSearch":"UhTZYuIc","Menu":"nTfYX7oL","MenuList":"_3XNYDX5","MenuOption":"qVQa4Fcg","MenuMessage":"k42aOX9p"};